import { render, staticRenderFns } from "./AddWechat.vue?vue&type=template&id=5aa1c552&scoped=true"
import script from "./AddWechat.vue?vue&type=script&lang=js"
export * from "./AddWechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa1c552",
  null
  
)

export default component.exports